import { jsx as _jsx } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import { EmailRenderer } from 'components/emailRenderer';
import { ConversationTextualMessage } from '../../textualMessage/conversationTextualMessage';
/**
 * Represents the component for displaying a conversation internal note event
 * group.
 */
export const ConversationInternalNoteEventGroup = ({ author, className, events, hideGutterActions, }) => {
    const timestamp = events[events.length - 1].created_at;
    return (_jsx(ConversationTextualMessage, Object.assign({ className: className, author: author, timestamp: timestamp, hideGutterActions: hideGutterActions, variant: "internalNote" }, { children: _jsx(FlexBox, Object.assign({ flexDirection: "column", gap: "200", style: { wordBreak: 'break-word' } }, { children: events.map((event) => (_jsx(FlexBox, Object.assign({ flexDirection: "column", gap: "100" }, { children: _jsx(EmailRenderer, { html: event.message }) }), event.id))) })) })));
};
